// extracted by mini-css-extract-plugin
export default {"select":"ZHy7H","icon":"tnqQp","text":"YmYa_"};